import { LocationExceptionalStatusType } from "src/store/api/generatedApi";

type TranslationKey =
  | "exceptionalStatusMissing"
  | "exceptionalStatusIgnorable"
  | "exceptionalStatusBadLabels"
  | "exceptionalStatusBrokenScaleWeights";

export const getExceptionalStatusTranslationKey = (
  status: LocationExceptionalStatusType
): TranslationKey => {
  switch (status) {
    case "missing":
      return "exceptionalStatusMissing";
    case "ignorable":
      return "exceptionalStatusIgnorable";
    case "bad_labels":
      return "exceptionalStatusBadLabels";
    case "broken_scale_weights":
      return "exceptionalStatusBrokenScaleWeights";
  }
};
